<template>
    <div class="timer-container">
        <transition>
            <timer
                v-if="showTimer"
                :seconds="timeInSeconds"
                :total="totalTime"
                :state="state"
                :theme="user.modules.overlay.theme"
            />
        </transition>

        <!-- <span>Make it like spotify  00:20 [==o-------------] 3:10 </span> -->

        <div class="buttons">
            <button @click="setTimer(35)">Set timer (2m)</button>
            <button @click="startTimer">Start timer</button>
            <button @click="startStopWatch">Start stopwatch</button>
            <button @click="pauseTimer">Pause timer</button>
            <button @click="addTime('5s')">Add 5 seconds</button>
            <button @click="resetTimer">Reset Timer</button>
            <button @click="playSound">Play sound</button>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import Timer from "@/components/widgets/Timer";

export default {
    name: "Timers",
    data: () => ({
        showTimer: false,
        state: false,
        totalTime: null,
        timeInSeconds: null,
        interval: null,
        removeTimerInterval: null,
        voice: "justin",
        user: null,
        client: null,
    }),
    mounted() {
        const vm = this;

        api.getUserByUUID(this.$route.params.uuid)
            .then(user => {
                vm.user = user;
            })
            .catch(err => {
                console.log(err);
            });
    },
    methods: {
        setTimer: function(seconds) {
            // Set up the timer
            this.timeInSeconds = seconds;
            this.totalTime = seconds;
            this.showTimer = true;
            this.state = "inactive";
        },
        startTimer: function() {
            // Continue the timer
            const vm = this;
            if (vm.state === "active") return;

            vm.interval = setInterval(function() {
                vm.timeInSeconds = vm.timeInSeconds - 1;
            }, 1000);
            this.state = "active";
        },
        startStopWatch: function() {
            const vm = this;

            if (vm.state === "active") return;

            vm.interval = setInterval(function() {
                vm.timeInSeconds = vm.timeInSeconds + 1;
            }, 1000);
            this.state = "active";
        },
        pauseTimer: function() {
            // Pause the timer
            if (this.state !== "active") return;

            clearInterval(this.interval);
            this.state = "paused";
        },
        endTimer: function() {
            const vm = this;
            this.pauseTimer();
            this.state = "ended";

            this.removeTimerInterval = setTimeout(function() {
                vm.resetTimer();
            }, 15 * 1000);
        },
        resetTimer: function() {
            clearInterval(this.interval);
            this.totalTime = null;
            this.timeInSeconds = null;
            this.state = "inactive";
            this.showTimer = false;
        },
        addTime: function(time) {
            const seconds = this.getSecondsFromString(time);
            this.totalTime += seconds;
            this.timeInSeconds += seconds;
        },
        playSound: function(sound) {
            const audio = new Audio(sound);
            audio.play();
        },
        getSecondsFromString: function(string) {
            const unit = string.slice(-1);
            const time = parseInt(string.substring(0, string.length - 1));

            if (unit === "s") {
                return time;
            } else if (unit === "m") {
                return time * 60;
            } else if (unit === "h") {
                return time * 60 * 60;
            } else {
                return time;
            }
        },
    },
    watch: {
        timeInSeconds: function(value) {
            if (value === 60 * 5) {
                this.playSound(require(`@/assets/${this.voice}_5m.mp3`));
            }

            if (value === 30) {
                this.playSound(require(`@/assets/${this.voice}_30s.mp3`));
            }

            if (value === 0) {
                this.playSound(require(`@/assets/${this.voice}_timeup.mp3`));
            }

            if (value <= 0) {
                this.endTimer();
            }
        },
    },
    computed: {},
    components: { Timer },
};
</script>

<style lang="scss" scoped>
.timer-container {
    justify-content: center;
    align-items: center;
    display: flex;
}

.buttons {
    position: fixed;
    bottom: 0;
}
</style>
